import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
// import editIcon from '../../assets/images/icons/icon-edit.svg';
// import delIcon from '../../assets/images/icons/icon-delete.svg';
import warningIcon from '../../assets/images/status-icon.svg';
import CommonModal from '../Modals/CommonModal';
import decryptData from '../../helpers/Decryption';

const Stations = () => {
    const [stations, setStations] = useState([]);
    const [agencies, setAgencies] = useState([]); // New state for agencies
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [statusFilter, setStatusFilter] = useState('');
    const [agencyFilter, setAgencyFilter] = useState(''); // New state for agency filter
    const [searchQuery, setSearchQuery] = useState('');
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [measuringUnit, setMeasuringUnit] = useState('');
    const navigate = useNavigate();
    const { state } = useLocation();
    const { getToken } = useAuth();
    const [messageShown, setMessageShown] = useState(false);

    useEffect(() => {
        if (state?.message && !messageShown) {
            toast.success(state.message);
            setMessageShown(true);
            navigate('/stops', { replace: true, state: {} });
        }
    }, [state, messageShown, navigate]);

    useEffect(() => {
        getAllStations();
        getMeasuringUnits();
        getAllAgencies(); // Fetch agencies on mount
    }, []);

    const getMeasuringUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code === 200) {
                        setMeasuringUnit(res.data?.distanceUnit || 'km');
                    }
                })
                .catch((err) => {});
        }
    };

    const getAllAgencies = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllAgencies(token) // Assume this API exists
                .then(async (res) => {
                    if (res?.code === 200) {
                        const data = typeof res.data === 'string' ? await decryptData(res.data) : res.data;
                        setAgencies(data?.agencies || []);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching agencies:', err);
                });
        }
    };

    const getAllStations = async (_pageSize = pageSize, _pageNo = offset, _status = statusFilter, _search = searchQuery, _agency = agencyFilter) => {
        const token = getToken();
        if (token) {
            setLoading(true);
            new WebApiCalls()
                .getAllStations(token, _pageSize, _pageNo, _status, _search, '', _agency) // Pass agency filter
                .then(async (res) => {
                    if (res?.code === 200) {
                        const data = await decryptData(res.data);
                        setStations(data?.stations || []);
                        setTotalRecords(data?.totalRecords || 0);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching stations:', err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .stationDelete(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Station deleted successfully');
                        getAllStations();
                    }
                })
                .catch((err) => {});
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Agency</span>
                </h6>
            ),
            selector: (row) => row.agency_ids?.map((agency) => agency.name).join(', ') || 'N/A',
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row.status}
                    onChange={(e) => updateSingleStatus(row._id, e.target.value)}
                    className={row.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Station status"
                >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                </select>
            ),
            center: true,
            minWidth: '130px'
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Actions</span>
                </h6>
            ),
            cell: (row) => (
                <div className="d-flex justify-content-center">
                    <OverlayTrigger overlay={<Tooltip>View Details</Tooltip>}>
                        <img
                            src={viewIcon}
                            className="me-2 action-icon"
                            onClick={() =>
                                navigate(`/stops/stop-detail`, {
                                    state: {
                                        station_id: row?._id,
                                        route_id: '',
                                        redirect_url: '/stops'
                                    }
                                })
                            }
                            alt="view"
                        />
                    </OverlayTrigger>
                </div>
            ),
            center: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                height: '55px',
                display: 'flex',
                alignItems: 'center'
            }
        },
        headCells: {
            style: {
                height: '52px',
                paddingLeft: '8px',
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px'
            }
        }
    };

    const handlePageChange = (page) => {
        setOffset(page);
        getAllStations(pageSize, page, statusFilter, searchQuery, agencyFilter);
    };

    const handlePerRowsChange = async (newPageSize, page) => {
        setPageSize(newPageSize);
        getAllStations(newPageSize, page, statusFilter, searchQuery, agencyFilter);
    };

    const handleRowSelected = React.useCallback((state) => {
        setSelectedRows(state.selectedRows.map((row) => row._id));
    }, []);

    const updateBulkStatus = async (status) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .updateBulkStations(token, { _ids: selectedRows, status })
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success(`${selectedRows.length} stations updated`);
                        getAllStations();
                        setToggleCleared(!toggleCleared);
                    }
                })
                .catch((err) => {});
        }
    };

    const updateSingleStatus = async (stationId, status) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .updateStationStatus(token, stationId, { status })
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Station status updated');
                        getAllStations();
                    }
                })
                .catch((err) => {});
        }
    };

    const deleteBulk = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .stationBulkDelete(token, { _ids: selectedRows })
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success(`${selectedRows.length} stations deleted`);
                        getAllStations();
                        setToggleCleared(!toggleCleared);
                    }
                })
                .catch((err) => {});
        }
    };

    const searchDebounce = _.debounce((text) => {
        setSearchQuery(text);
        getAllStations(pageSize, offset, statusFilter, text, agencyFilter);
    }, 500);

    return (
        <div style={{ padding: '20px' }}>
            {/* Modals */}
            <CommonModal show={showDelModal} handleClose={() => setShowDelModal(false)} handleDelete={handleDelete} text="Delete this station?" />
            <CommonModal show={showBulkDel} handleClose={() => setShowBulkDel(false)} handleDelete={deleteBulk} text="Delete selected stations?" />
            <Modal centered show={changeStatusModal} onHide={() => setChangeStatusModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Status</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={warningIcon} alt="warning" className="mb-3" />
                    <p>Change status for {selectedRows.length} stations?</p>
                    <div className="d-flex gap-3 justify-content-center">
                        <Button
                            variant="success"
                            onClick={() => {
                                updateBulkStatus('active');
                                setChangeStatusModal(false);
                            }}
                        >
                            Active
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => {
                                updateBulkStatus('inactive');
                                setChangeStatusModal(false);
                            }}
                        >
                            Inactive
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Controls */}
            <Row className="mb-4">
                <Col sm={3} md={3} style={{ paddingRight: 0 }} className="my-3 my-sm-0">
                    <input type="text" className="search-input-bar" placeholder="Search stations..." onChange={(e) => searchDebounce(e.target.value)} />
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-2 justify-content-start">
                        <select
                            className="status-selector w-120"
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                getAllStations(pageSize, offset, e.target.value, searchQuery, agencyFilter);
                            }}
                        >
                            <option value="">All Statuses</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                        <select
                            className="status-selector w-120"
                            value={agencyFilter}
                            onChange={(e) => {
                                setAgencyFilter(e.target.value);
                                getAllStations(pageSize, offset, statusFilter, searchQuery, e.target.value);
                            }}
                        >
                            <option value="">All Agencies</option>
                            {agencies.map((agency) => (
                                <option key={agency._id} value={agency._id}>
                                    {agency.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </Col>
                <Col md={4} className="text-end">
                    {selectedRows.length > 0 && (
                        <>
                            <Button variant="warning" className="me-2" onClick={() => setChangeStatusModal(true)}>
                                Change Status
                            </Button>
                            <Button variant="danger" className="me-2" onClick={() => setShowBulkDel(true)}>
                                Delete Selected
                            </Button>
                        </>
                    )}
                </Col>
            </Row>

            {/* Data Table */}
            <DataTable
                columns={columns}
                data={stations}
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                selectableRows
                direction="auto"
                responsive
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                subHeaderWrap
                customStyles={customStyles}
                dense
                progressPending={loading}
            />
        </div>
    );
};

export default Stations;
